<template>
  <div class="record-container">
    <div v-if="show">
      <div v-if="recordList.length > 0">
        <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          offset="100"
        > -->
        <div
          class="record-list-item"
          v-for="(item, index) in recordList"
          @click="toHeadcertification()"
          :key="index"
        >
          <div class="item-container">
            <h3 class="item-name">{{ name }}</h3>
            <div class="item-bottom">
              <div class="date">
                <span>认证时间：</span>
                {{ item.checkTime }}
              </div>
              <div class="mark bg1">认证成功</div>
              <!-- <div v-else class="mark bg2">认证失败</div> -->
            </div>
          </div>
        </div>
        <!-- </van-list>
      </van-pull-refresh> -->
      </div>

      <div class="record-box" v-else>
        <div class="img-box"></div>
        <div class="text-box">
          <p>当前暂无认证记录</p>
          <p>请点击下方认证按钮，尽快开始验证吧。</p>
        </div>
      </div>
      <div v-if="!haveChecked" class="record-btn" @click="handleClick">
        立即认证
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoByIdcard } from "@/api/attest";
export default {
  data() {
    return {
      offset: 100,
      isLoading: false,
      loading: false,
      pageNow: 1,
      finished: false,
      idcard: "",
      applyId: "",
      settingId: "",
      haveChecked: "",
      recordList: [],
      name: "",
      show: false,
    };
  },
  methods: {
    onLoad() {
      console.log("哈哈");
      if (this.pageNow === 1) {
        return;
      } else {
        this.getList();
      }
    },
    toHeadcertification() {},
    onRefresh() {
      this.recordList = [];
      this.pageNow = 1;
      this.finished = false;
      this.loading = true;
      this.getList();
    },
    handleClick() {
      this.$router.push({
        path: "/headcertification",
        query: { aId: this.applyId, sId: this.settingId },
      });
    },
    getList() {
      // verifyList({
      //   id: this.userInfo.id,
      //   pageNow: this.pageNow,
      // })
      //   .then((res) => {
      //     this.loading = false;
      //     this.isLoading = false;
      //     if (res.data.list.length <script 10) {
      //       this.finished = true;
      //     } else {
      //       this.pageNow++;
      //     }
      //     this.recordList = this.recordList.concat(res.data.list);
      //   })
      //   .catch((res) => {
      //     if (res.status == "2") {
      //       this.$router.push({
      //         path: "/attest",
      //         query: {},
      //       });
      //     }
      //   });

      getInfoByIdcard({
        areaName:this.$route.query.areaName,
        idcard:this.$route.query.idcard,
        t:this.$route.query.t,
        sign:this.$route.query.sign,
      }).then((res) => {
        this.recordList = res.data.benefitRecord || [];
        this.haveChecked = res.data.benefitUserInfo.haveChecked;
        this.applyId = res.data.benefitUserInfo.applyId;
        this.settingId = res.data.benefitUserInfo.settingId;
        this.name = res.data.benefitUserInfo.name;
        this.show = true;
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.record-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f3f2f1;
  .record-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 119px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    color: #444545;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
  }
  .img-box {
    width: 62px;
    height: 52px;
    background: url("../../assets/img_null2.png") no-repeat center;
    background-size: 62px 52px;
    overflow: hidden;
    margin-bottom: 25px;
  }
  .text-box {
    font-family: PingFang SC;
    font-weight: 400;
    color: #444545;
    p:first-child {
      margin-bottom: 24px;
    }
    p {
      text-align: center;
    }
  }
  .van-pull-refresh {
    background-color: #f3f2f1;
    padding-bottom: 60px;
  }
  .record-list-item {
    width: 100%;
    height: 100px;
    background-color: #fff;
    margin-bottom: 11px;
    padding: 0 18px;
    .item-name {
      width: 100%;
      height: 40px;
      color: #323333;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 40px;
      border-bottom: 1px solid #f5f5f5;
    }

    .item-bottom {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .date {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #575757;
    }
    .mark {
      width: 63px;
      height: 20px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      line-height: 20px;
    }
    .bg1 {
      background-color: #00dc9f;
    }
    .bg2 {
      background-color: #fd4c69;
    }
  }

  .record-btn {
    position: fixed;
    left: 50%;
    bottom: 20px;
    z-index: 99;
    transform: translateX(-50%);
    width: 339px;
    height: 46px;
    background-color: #2c66f8;
    border-radius: 3px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
  }
}
</style>